import { Heading } from "@radix-ui/themes";
import React from "react";

const NotFound = ({ fallback }: { fallback: string }): React.ReactElement => {
  return <Heading>{fallback}</Heading>;
};

export default NotFound;
